export default __webpack_public_path__ + "static/photo3usluge-2663df2abe830518f1445a5eb144ce05.png";